<template>
	<div class="contact-all-box">
		<div class="contact-all-search">
			<div class="contact-all-search-input">
				<input type="text" placeholder="请输入昵称/群名称" @focus="searchFocus">
				<span class="contact-all-search-icon"></span>
			</div>
			<div class="contact-all-search-filter" @click="customFilterClick">
			</div>
			<div class="contact-all-add">
			</div>
		</div>
		<div class="contact-all-fans">
			<div class="contact-all-wrap" id="contact-all-wrap" @scroll="chatScroll">
				<div class="contact-all-items">
					<div class="contact-all-item" v-for="(chat,key) in chatList" :key="'chat-all-'+chat.id" :class="{'contact-all-item-active':currentChat.id == chat.id}"
					 @click="chatClick(chat,key)" @contextmenu="rightClick(chat,$event)">
						<div class="contact-all-avatar">
							<img :src="chat.friend_img | connectHost" :title="chat.friend_name">
							<span class="contact-all-notice" v-if="chat.no_read_num > 0">{{chat.no_read_num | pass99}}</span>
						</div>
						<div class="contact-all-info">
							<div class="contact-all-title" :class="{'contact-all-transfer' : chat.is_transfer == 1}">{{chat.friend_name}}</div>
							<div class="contact-all-msg">
								<span class="contact-all-msg-desc">{{chat.last_chat_msg | formatRMsg(chat.last_chat_msg_type)}}</span>
								<span class="contact-all-msg-time">{{chat.last_modified_time | rechentDate}}</span>
							</div>
							<div class="contact-all-tips">
								<div class="contact-all-tip contact-all-no-disturb" v-if="chat.no_disturb == 1"></div>
								<div class="contact-all-tip contact-all-top" v-if="chat.is_top == 1"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="contact-all-refresh" v-if="!canRefresh">
					<img src="/img/loading.gif" alt="" v-if="!isEnd">
					<span v-if="!isEnd">数据加载中...</span>
					<span v-if="isEnd">{{chatList.length}}条记录</span>
				</div>
			</div>
		</div>
		<div class="contact-all-rightkey" id="contact-all-rightkey" v-show="optChat.id > 0">
			<div class="contact-all-rightkey-items">
				<div class="contact-all-rightkey-item" @click="msgTop">{{optChat.is_top == 0 ? '置顶' :'取消置顶'}}</div>
				<div class="contact-all-rightkey-item" @click="msgCollect">{{optChat.is_collect == 0 ? '收藏' :'取消收藏'}}</div>
				<div class="contact-all-rightkey-item" @click="msgNoDisturb">{{optChat.no_disturb == 0 ? '消息免打扰' :'取消免打扰'}}</div>
				<div class="contact-all-rightkey-item" @click="friendToGroup">
					<span>分组</span>
					<span>></span>
				</div>
				<div class="contact-all-rightkey-item" @click="delRecently">删除聊天</div>
				<div class="contact-all-rightkey-item contact-all-rightkey-cancel" @click="optChatCancel">取消</div>
			</div>
			<div class="contact-all-fans-group" v-if="friendGroupMenu && showFriendGroupMenu">
				<div class="contact-all-fans-group-items">
					<div class="contact-all-fans-group-item"
					 :class="{'contact-all-fans-group-item-del': optChat.selectGroup.indexOf(item.id) !== -1}"
					 v-for="item in friendGroup" 
					 @click="friendToGroupNow(item.id)">
					 {{item.title}}<span v-if="optChat.selectGroup.indexOf(item.id) !== -1">x</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getRecentlyList,
		updateNumRecentlyById,
		updateRecentlyByFIdAndType,
		getRecentlyByFIdAndType,
		updateRecentlyById,
		delRecentlyById
	} from '../../network/local/recently.js'
	import {
		getFansByCustomIdAndWxid
	} from '../../network/local/friend.js'
	import {
		getClusterById
	} from '../../network/local/cluster.js'
	import {
		webUpdateRecentlyById,
		webDelRecentlyById
	} from '../../network/web/recently.js'
	import {getFansInfo} from '../../util/msgUtil.js'
	import {webGetFansTransferList} from '../../network/web/manager.js'
	import {saveTransferData} from '../../network/local/fans-transfer.js'
	import {getLocalConfig} from '../../functions/Common.js'
	import {webBind} from '../../network/web/friend_group_rel.js'
	import {save as saveFGR,getByChattingId,deleteById} from '../../network/local/friend_group_rel.js'

	export default {
		name: 'ChatChatAll',
		props: {
			// 消息类型-个人-群-全部
			type: {
				type: String,
				default: 'all'
			},
			// 当前客服
			custom: {
				type: Object,
				default: function() {
					return {
						open_id: ''
					}
				}
			},
			// 最近聊天修改数据
			recentlyModify: {
				type: Object,
				default: function() {
					return {}
				}
			},
			// 跳转的需要聊天的粉丝
			jumpChat: {
				type: Object,
				default: function() {
					return {}
				}
			},
			// 需要删除的粉丝id
			delFansId: {
				type: Number,
				default: 0
			},
		},
		data() {
			return {
				filterOpen: false,
				canRefresh: false,
				isEnd: false,
				lastTime: 0,
				scrollTop: 0,
				chatList: [],
				currentChat: {
					id: 0,
					name: "",
					avatar: '',
					lastMsg: '',
					lastTime: '',
					noticeNum: 0
				},
				optChat: {
					id: 0,
					selectGroup: []
				},
				friendGroupMenu: false,
				showFriendGroupMenu: false,
				friendGroup: []
			}
		},
		components: {

		},
		methods: {
			// 初始化原始数据
			initData() {
				this.lastTime = 0
				this.chatList = []
				this.canRefresh = false
				this.isEnd = false
				this.scrollTop = 0
				this.closeMenu()
			},

			// 聊天项目点击切换
			chatClick(value, index) {
				// 获取粉丝信息，只为更新粉丝信息到本地库-不存在才更新
				if(value.chat_type !== undefined && value.chat_type == 1){
					getFansInfo(value.friend_or_cluster_id,res=>{
						this.chatClickCall(value,index)
					})
				}else{
					this.chatClickCall(value,index)
				}
			},
			
			// 聊天项目点击切换-数据渲染
			chatClickCall(value,index){
				this.currentChat = value
				this.closeMenu()
				if (value.no_read_num > 0) {
					// 更新最近聊天记录表与本地信息
					updateNumRecentlyById(value.id, 0, () => {
						this.chatList[index].no_read_num = 0
						this.$emit("compute-not-read", value.account_open_id)
					})
					// 更新线上数据库
					webUpdateRecentlyById({
						id: value.id,
						is_new: 0
					}, () => {
						this.$emit('chat-click', value)
					})
				}else{
					this.$emit('chat-click', value)
				}
			},

			// 客服过滤按钮点击
			customFilterClick() {
				this.filterOpen = !this.filterOpen
				this.$emit('custom-filter', this.filterOpen)
			},

			// 滚动刷新数据
			chatScroll(event) {
				let page = document.getElementById("contact-all-wrap")
				this.scrollTop = page.scrollTop
				if (page.scrollTop + page.clientHeight >= page.scrollHeight - 25 && this.canRefresh) {
					this.canRefresh = false
					this.showData()
				}
			},

			// 获取数据，并渲染列表
			showData() {
				if(this.type === 'fans_transfer'){
					webGetFansTransferList((data)=>{
						saveTransferData(data.data,()=>{
							let c_data = []
							if(data.code == 1){
								c_data = data.data.recently
							}
							this.canRefresh = false
							this.isEnd = true
							this.chatList = c_data
						})
					})
				}else{
					getRecentlyList(this.custom.open_id, this.type, this.lastTime, (data) => {
						let len = data.length
						if (len > 0) {
							for (let i = 0; i < len; i++) {
								this.chatList.push(data[i])
							}
							if (data[len - 1].is_top !== 1) {
								this.lastTime = data[len - 1].last_modified_time
							}
							this.canRefresh = true
						} else {
							this.canRefresh = false
							this.isEnd = true
						}
					})
				}
			},

			// 删除群-只是页面渲染
			deleteRoom(id) {
				if (id !== undefined && id > 0 && this.chatList.length > 0) {
					for (let i = 0; i < this.chatList.length; i++) {
						if (this.chatList[i].friend_or_cluster_id == id && this.chatList[i].chat_type == 2) {
							this.chatList.splice(i, 1)
							break
						}
					}
				}
				this.$emit('cluster-delete-call', id)
			},

			// 更新群昵称
			updateList(id, name) {
				if (id !== undefined && id > 0 && this.chatList.length > 0) {
					for (let i = 0; i < this.chatList.length; i++) {
						if (this.chatList[i].friend_or_cluster_id == id && this.chatList[i].chat_type == 2) {
							this.chatList[i].friend_name = name
							// break
						}
					}
				}
			},

			// 更新粉丝备注
			updateListByRemark(id, name) {
				if (id !== undefined && id > 0 && this.chatList.length > 0) {
					for (let i = 0; i < this.chatList.length; i++) {
						if (this.chatList[i].friend_or_cluster_id == id && this.chatList[i].chat_type == 1) {
							this.chatList[i].friend_name = name
							break
						}
					}
				}
			},

			// 搜索框聚焦事件
			searchFocus() {
				this.$emit('search-show-call', true)
			},

			// 最近聊天记录修改
			handleRecentlyModify(data) {
				if (data.id === undefined) {
					return
				}
				// 查找当前id是否已经在渲染的列表中
				let index = -1
				let recently = {}
				for (let i = 0; i < this.chatList.length; i++) {
					if (this.chatList[i].id == data.id) {
						index = i
						recently = this.chatList[i]
						break
					}
				}
				if (index == -1) {
					return
				}
				// 置顶处理
				if (data.is_top !== undefined) {
					recently.is_top = data.is_top
					// 置顶
					if (data.is_top == 1) {
						this.chatList.splice(index, 1)
						this.chatList.unshift(recently)
					}
					// 取消置顶
					else {
						this.chatList.splice(index, 1)
						let lastRecently = this.chatList[this.chatList.length - 1]
						if (lastRecently.is_top !== 1 && recently.last_modified_time < lastRecently.last_modified_time) {
							return
						}
						for (let i = 0; i < this.chatList.length; i++) {
							if (this.chatList[i].is_top == 0) {
								this.chatList.splice(i, 0, recently)
								break
							}
						}
					}
				}
				// 处理收藏-只有停留在收藏页面时操作
				if (data.is_collect !== undefined) {
					recently.is_collect = data.is_collect
					if(data.is_collect === 0 && this.type === 'collection'){
						this.chatList.splice(index, 1)
					}
				}
			},

			// 处理跳转过来的粉丝-基本数据拼接
			getJumpFans(jData) {
				if (jData.type === undefined) {
					return
				}
				// 处理粉丝类型的
				if (jData.type === 'fans') {
					getFansByCustomIdAndWxid(jData.c_id, jData.f_wxid, fans => {
						if (fans.id === undefined) {
							return
						}
						let data = {
							id: 0,
							account_open_id: jData.c_wxid,
							friends_open_id: fans.open_id,
							friend_or_cluster_id: fans.id,
							friend_img: fans.wx_photo,
							friend_name: fans.wx_name,
							chat_type: 1,
							last_chat_msg: '',
							last_chat_msg_type: 'text',
							last_modified_time: 0,
							is_new: 0,
							is_top: 0,
							is_collect: 0,
							no_read_num: 0,
							no_disturb: 0
						}
						this.showJumpFans(data)
					})
				} else if (jData.type === 'cluster') {
					getClusterById(jData.f_wxid, cluster => {
						if (cluster.id !== undefined) {
							let data = {
								id: 0,
								account_open_id: jData.c_wxid,
								friends_open_id: cluster.wechat_cluster_id,
								friend_or_cluster_id: cluster.id,
								friend_img: cluster.cluster_photo,
								friend_name: cluster.cluster_name,
								chat_type: 2,
								last_chat_msg: '',
								last_chat_msg_type: 'text',
								last_modified_time: 0,
								is_new: 0,
								is_top: 0,
								is_collect: 0,
								no_read_num: 0,
								no_disturb: 0
							}
							this.showJumpFans(data)
						}
					})
				} else if (jData.type === 'recently') {
					getRecentlyByFIdAndType(jData.fansId, jData.chatType, data => {
						this.showJumpFans(data)
					})
				}
			},
			// 处理跳转过来的粉丝-页面展示渲染
			showJumpFans(data) {
				if (data.friend_or_cluster_id === undefined || data.chat_type === null) {
					return
				}
				// 获取不置顶的第一个索引
				let notTopIndex = 0
				for (let i = 0; i < this.chatList.length; i++) {
					if (this.chatList[i].is_top == 0) {
						notTopIndex = i
						break
					}
				}
				// 判断当前聊天对象再已渲染的列表中是否存在-存在的话直接置顶
				for (let i = 0; i < this.chatList.length; i++) {
					if (this.chatList[i].friend_or_cluster_id == data.friend_or_cluster_id && this.chatList[i].chat_type == data.chat_type) {
						let chat = JSON.parse(JSON.stringify(this.chatList[i]))
						this.chatList.splice(i, 1)
						if (chat.is_top === 1) {
							this.chatList.unshift(chat)
						} else {
							this.chatList.splice(notTopIndex, 0, chat)
						}
						this.currentChat = chat
						this.$emit('chat-click', chat)
						return
					}
				}
				// 如果在已渲染的列表中不存在，再查询本地数据库，并更改聊天的最后时间
				getRecentlyByFIdAndType(data.friend_or_cluster_id, data.chat_type, res => {
					// 更新列表
					if (res) {
						let last_modified_time = new Date().getTime()
						updateRecentlyByFIdAndType(data.friend_or_cluster_id, data.chat_type, {
							last_modified_time: last_modified_time
						}, u_res => {
							res.last_modified_time = last_modified_time
							if (res.is_top === 1) {
								this.chatList.unshift(res)
							} else {
								this.chatList.splice(notTopIndex, 0, res)
							}
							this.currentChat = res
							this.$emit('chat-click', res)
						})
					}
					// 如果都没有，则直接添加新的数据
					else {
						let last_modified_time = new Date().getTime()
						let chat = JSON.parse(JSON.stringify(data))
						chat.last_modified_time = last_modified_time
						chat.id = last_modified_time
						chat.isTemp = true
						this.chatList.splice(notTopIndex, 0, chat)
						this.currentChat = chat
						this.$emit('chat-click', chat)
					}
				})
			},

			// 删除列表粉丝
			deleteFans(fansId, type) {
				if (fansId !== undefined && fansId > 0 && this.chatList.length > 0) {
					for (let i = 0; i < this.chatList.length; i++) {
						if (this.chatList[i].friend_or_cluster_id == fansId && this.chatList[i].chat_type == type) {
							this.chatList.splice(i, 1)
							break
						}
					}
				}
			},

			// 菜单右键点击
			rightClick(chat, event) {
				this.showFriendGroupMenu = false
				// 屏蔽默认事件
				event.preventDefault()
				// 判断当前操作对象是否为自己，如果是则关闭
				if (this.optChat.id != 0 && this.optChat.id === chat.id) {
					this.closeMenu()
					return
				}
				// 定位
				var menu = document.querySelector("#contact-all-rightkey")
				let appObj = document.querySelector("#container")
				let appHeight = 800
				if (appObj !== undefined) {
					appHeight = appObj.clientHeight
				}
				appHeight = Math.ceil(appHeight / 2)
				// LEFT距离计算
				let offsetX = 0
				let limitX = 320
				if(this.friendGroupMenu){
					limitX = limitX - 80
				}
				if (event.clientX > limitX) {
					offsetX = 240
					if(this.friendGroupMenu){
						offsetX = offsetX - 80
					}
				} else {
					offsetX = event.clientX - 80
				}
				if (this.filterOpen) {
					offsetX = offsetX - 80
				}
				// TOP距离计算
				let offSetY = 0
				if (event.clientY > appHeight) {
					offSetY = (event.clientY - 130 - 96)
				} else {
					offSetY = (event.clientY - 130)
				}
				menu.style.left = offsetX + 'px'
				menu.style.top = offSetY + 'px'
				// 获取此聊天的所有标签组
				getByChattingId(chat.id,data=>{
					let selectGroup = []
					if(data !== false){
						for (let i = 0; i < data.length; i++) {
							selectGroup.push(data[i].group_id)
						}
					}
					chat.selectGroup = selectGroup
					this.optChat = chat
				})
			},

			// 置顶操作
			msgTop() {
				if (this.optChat.is_top == 0) {
					this.optChat.is_top = 1
				} else {
					this.optChat.is_top = 0
				}
				let param = {
					id: this.optChat.id,
					is_top: this.optChat.is_top
				}
				webUpdateRecentlyById(param, u_res => {
					updateRecentlyById(this.optChat.id, param, res => {
						CHAT_LAYER.msg('修改成功', {
							icon: 1
						})
						this.$emit('recently-modify-call', param)
						this.closeMenu()
					})
				})
			},

			// 收藏操作
			msgCollect() {
				if (this.optChat.is_collect == 0) {
					this.optChat.is_collect = 1
				} else {
					this.optChat.is_collect = 0
				}
				let param = {
					id: this.optChat.id,
					is_collect: this.optChat.is_collect
				}
				webUpdateRecentlyById(param, u_res => {
					updateRecentlyById(this.optChat.id, param, res => {
						CHAT_LAYER.msg('修改成功', {
							icon: 1
						})
						this.$emit('recently-modify-call', param)
						this.closeMenu()
					})
				})
			},
			
			// 消息免打扰操作
			msgNoDisturb(){
				if (this.optChat.no_disturb == 0) {
					this.optChat.no_disturb = 1
				} else {
					this.optChat.no_disturb = 0
				}
				let param = {
					id: this.optChat.id,
					no_disturb: this.optChat.no_disturb
				}
				webUpdateRecentlyById(param, u_res => {
					updateRecentlyById(this.optChat.id, param, res => {
						CHAT_LAYER.msg('修改成功', {
							icon: 1
						})
						this.$emit('recently-modify-call', param)
						this.closeMenu()
					})
				})
			},

			// 删除当前聊天
			delRecently() {
				let _this = this
				CHAT_LAYER.confirm('确认要删除与"<span style="color: red">' + this.optChat.friend_name + '</span>"的聊天吗？', {
						btn: ['确认', '取消']
					},
					function(index, layero) {
						webDelRecentlyById(_this.optChat.id, res => {
							delRecentlyById(_this.optChat.id, l_res => {
								CHAT_LAYER.msg('删除成功', {
									icon: 1
								})
								_this.deleteFans(_this.optChat.friend_or_cluster_id, _this.optChat.chat_type)
								_this.closeMenu()
							})
						})
					},
					function(index) {
						_this.closeMenu()
					})
			},
			
			// 操作取消
			optChatCancel(){
				this.closeMenu()
			},
			
			// 页面通知跳转
			pageNotice(val){
				this.getJumpFans(val.info)
			},
			
			// 粉丝聊天分组-打开或折叠
			friendToGroup(){
				this.showFriendGroupMenu = !this.showFriendGroupMenu
			},
			
			// 粉丝聊天分组-处理数据
			friendToGroupNow(group_id){
				let param = {
					client_type: 1,
					custom_id: 0,
					fans_id: this.optChat.friend_or_cluster_id,
					chatting_id: this.optChat.id,
					group_id: group_id
				}
				// 先在web端保存，然后保存到本地
				webBind(param,data=>{
					if(data.code == 1){
						let c_data = data.data
						if(c_data.type === 'insert'){
							saveFGR(c_data,l_data=>{
								if(l_data !== false){
									CHAT_LAYER.msg('操作成功',{icon: 1})
								}else{
									CHAT_LAYER.msg('操作失败',{icon: 2})
								}
							})
						}else if(c_data.type === 'del'){
							deleteById(c_data.id,l_data=>{
								if(l_data !== false){
									CHAT_LAYER.msg('取消成功',{icon: 1})
								}else{
									CHAT_LAYER.msg('取消失败',{icon: 2})
								}
							})
						}
					}else{
						CHAT_LAYER.msg(data.msg,{icon: 2})
					}
					this.closeMenu()
				})
			},
			
			// 初始部分参数
			initConfig(){
				let friend_group = getLocalConfig('friend_group')
				if(friend_group === ''){
					return
				}
				friend_group = JSON.parse(friend_group)
				if(!(friend_group instanceof Array) ||  friend_group.length === 0){
					return
				}
				this.friendGroupMenu = true
				this.friendGroup = friend_group
			},
			
			// 关闭菜单
			closeMenu(){
				this.optChat = {
					id: 0,
					selectGroup: []
				}
			}
		},

		// 生命周期函数-组件创建时
		created() {
			this.showData()
			this.initConfig()
		},

		// 只有组件被缓存时，才会调用这2个方法
		activated() {
			let page = document.getElementById("contact-all-wrap")
			page.scrollTop = this.scrollTop
		},

		computed: {
			// 返回vuex中的最新最近聊天信息
			newRecently() {
				return this.$store.state.currentRecentlyMsg
			},

			// 返回vuex中的事件信息
			otherEvent() {
				return this.$store.state.otherEvent
			}
		},

		// 数据监听
		watch: {
			// 监听消息类型变化
			type(nVal, oVal) {
				if(nVal === 'more'){
					return
				}
				this.initData()
				this.showData()
			},

			// 监听客服变化
			custom(nVal, oVal) {
				this.initData()
				this.showData()
			},

			// 监听最近一条聊天记录的变化
			newRecently(nVal, oVal) {
				this.$emit("compute-not-read", nVal.account_open_id)
				// 判断新消息是否为当前的客服的，如果是聚合，则不判断
				if (this.custom.id > 0 && this.custom.open_id !== nVal.account_open_id) {
					return
				}

				let index = -1
				let notTopIndex = 0
				for (let i = 0; i < this.chatList.length; i++) {
					// 普通消息，根据粉丝id，和类型查询
					if(nVal.chat_type == 1){
						if (this.chatList[i].friend_or_cluster_id == nVal.friend_or_cluster_id && this.chatList[i].chat_type == nVal.chat_type) {
							index = i
							break
						}
					}
					// 群消息，根据群id，类型，客服wxid查询
					else{
						if (this.chatList[i].friend_or_cluster_id == nVal.friend_or_cluster_id && this.chatList[i].chat_type == nVal.chat_type && this.chatList[i].account_open_id == nVal.account_open_id) {
							index = i
							break
						}
					}
				}
				for (let i = 0; i < this.chatList.length; i++) {
					if (this.chatList[i].is_top == 0) {
						notTopIndex = i
						break
					}
				}
				if(nVal.msgToUp !== undefined && nVal.msgToUp === 0){
					return
				}
				let newVal = JSON.parse(JSON.stringify(nVal))
				// 未开启消息免打扰并且消息需要置顶的正常操作
				if(nVal.no_disturb === undefined || nVal.no_disturb !== 1){
					// 处理置顶的聊天
					if (nVal.is_top == 1) {
						if (index === -1) {
							this.chatList.unshift(newVal)
						} else {
							this.chatList.splice(index, 1)
							this.chatList.unshift(newVal)
						}
					}
					// 处理未置顶的聊天
					else {
						if (index === -1) {
							this.chatList.splice(notTopIndex, 0, newVal)
						} else {
							this.chatList.splice(index, 1)
							this.chatList.splice(notTopIndex, 0, newVal)
						}
					}
				}
				// 开启消息免打扰的，存在的不改变位置，不存在的放到第一个
				else{
					// 处理置顶的聊天
					if (nVal.is_top == 1) {
						if (index === -1) {
							this.chatList.unshift(newVal)
						} else {
							this.chatList.splice(index, 1, newVal)
						}
					}
					// 处理未置顶的聊天
					else {
						if (index === -1) {
							this.chatList.splice(notTopIndex, 0, newVal)
						} else {
							this.chatList.splice(index, 1, newVal)
						}
					}
				}
			},

			// 监听socket事件
			otherEvent(nVal, oVal) {
				if (nVal.type === undefined) {
					return
				}
				switch (nVal.type) {
					case 'C_ExitChatRoom':
						this.deleteRoom(nVal.clusterId)
						break
					case 'AT_update_cluster_name':
						this.updateList(nVal.clusterId, nVal.clusterName)
						break
					case 'reConRemark':
						this.updateListByRemark(nVal.friend_id, nVal.con_remark)
						break
					case 'FriendHide':
						this.deleteFans(nVal.f_id, 1)
						break
					case 'pageNotice':
						this.pageNotice(nVal)
						break
				}
			},

			// 监听从其他页面跳转过来的聊天
			jumpChat(nVal) {
				this.getJumpFans(nVal)
			},

			// 监听最近聊天记录修改
			recentlyModify(nVal) {
				this.handleRecentlyModify(nVal)
			},
			
			// 删除粉丝对应的记录
			delFansId(nVal){
				if(nVal > 0){
					for (let i = 0; i < this.chatList.length; i++) {
						if(this.chatList[i].friend_or_cluster_id == nVal && this.chatList[i].chat_type == 1){
							this.chatList.splice(i,1)
							break;
						}
					}
				}
			}
		}
	}
</script>
<style>
	.contact-all-box {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.contact-all-box .contact-all-search {
		width: 100%;
		padding: 0 20px;
		height: 50px;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
	}

	.contact-all-search .contact-all-search-input {
		width: 0;
		height: 30px;
		position: relative;
		flex-grow: 1;
		margin-right: 8px;
	}

	.contact-all-search .contact-all-search-input input {
		display: block;
		height: 30px;
		line-height: 30px;
		width: 100%;
		border: 1px solid #CFCFCF;
		border-radius: 4px;
		padding: 0 10px 0 30px;
		box-sizing: border-box;
		font-size: 12px;
	}

	.contact-all-search .contact-all-search-input input:focus {
		outline: none;
		border: 1px solid #42B983;
	}

	.contact-all-search-input .contact-all-search-icon {
		width: 30px;
		height: 30px;
		position: absolute;
		top: 0;
		left: 0;
		background-image: url(../../assets/img/c-all-search.png);
		background-size: 18px auto;
		background-repeat: no-repeat;
		background-position: center;
	}

	.contact-all-search .contact-all-search-filter,
	.contact-all-search .contact-all-add {
		width: 26px;
		height: 26px;
		background-size: 14px auto;
		background-repeat: no-repeat;
		background-position: center;
		border: 1px solid #b1b1b1;
		border-radius: 15px;
		cursor: pointer;
	}

	.contact-all-search .contact-all-search-filter {
		background-image: url(../../assets/img/c-all-filter.png);
	}

	.contact-all-search .contact-all-add {
		background-image: url(../../assets/img/c-all-add.png);
		margin-left: 8px;
	}

	.contact-all-box .contact-all-fans {
		position: absolute;
		top: 50px;
		left: 0;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}

	.contact-all-fans .contact-all-wrap {
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.contact-all-wrap::-webkit-scrollbar-thumb:hover {
		background: #868686;
	}

	.contact-all-wrap .contact-all-items {
		width: 100%;
		height: auto;
	}

	.contact-all-items .contact-all-item {
		width: 100%;
		height: 62px;
		padding: 10px 20px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-between;
		cursor: pointer;
		overflow: hidden;
		box-sizing: border-box;
	}

	.contact-all-items .contact-all-item:hover {
		background-color: #d8d8d8;
	}

	.contact-all-items .contact-all-item-active {
		background-color: #d8d8d8 !important;
	}

	.contact-all-item .contact-all-avatar {
		width: 42px;
		height: 42px;
		position: relative;
	}

	.contact-all-avatar img {
		width: 42px;
		height: 42px;
		border-radius: 2px;
		overflow: hidden;
	}

	.contact-all-avatar .contact-all-notice {
		display: block;
		position: absolute;
		top: -8px;
		right: -8px;
		padding: 0 3px;
		height: 16px;
		line-height: 16px;
		border-radius: 50%;
		text-align: center;
		background-color: #f14b13;
		color: #FFFFFF;
		font-size: 12px;
		min-width: 10px;
	}

	.contact-all-item .contact-all-info {
		width: 0;
		height: 42px;
		margin-left: 10px;
		text-align: left;
		flex-grow: 1;
		position: relative;
	}

	.contact-all-info .contact-all-title {
		height: 21px;
		line-height: 21px;
		font-size: 12px;
		font-weight: 600;
		color: #27354A;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	
	.contact-all-info .contact-all-transfer{
		color: #00899f !important;
	}

	.contact-all-info .contact-all-msg {
		height: 21px;
		line-height: 21px;
		font-size: 12px;
		color: #707070;
		display: flex;
		justify-content: space-between;
	}

	.contact-all-msg .contact-all-msg-desc {
		display: block;
		width: 0;
		flex-grow: 1;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.contact-all-msg .contact-all-msg-time {
		display: block;
		width: 80px;
		text-align: right;
		overflow: hidden;
	}

	.contact-all-info .contact-all-tips {
		position: absolute;
		top: 0;
		right: 0;
		width: auto;
		height: 16px;
		display: flex;
		justify-content: flex-end;
		align-content: center;
	}
	.contact-all-tips .contact-all-tip{
		width: 16px;
		height: 16px;
		background-size: 16px auto;
		background-repeat: no-repeat;
		background-position: center;
		margin-left: 5px;
	}
	.contact-all-tips .contact-all-top{
		background-image: url(../../assets/img/zhiding-acitve.png);
	}
	.contact-all-tips .contact-all-no-disturb{
		background-image: url(../../assets/img/no-disturb.png);
	}
	.contact-all-refresh {
		height: 36px;
		line-height: 36px;
		text-align: center;
		color: #42B983;
	}

	.contact-all-refresh>* {
		display: inline-block;
		vertical-align: middle;
	}

	.contact-all-refresh img {
		margin-right: 5px;
	}

	.contact-all-box .contact-all-rightkey {
		position: absolute;
		top: 0;
		left: 10px;
		width: 160px;
		background-color: #404040;
		z-index: 2;
		cursor: pointer;
		color: #FFFFFF;
		font-size: 12px;
		border-radius: 2px;
		color: #EEEEEE;
	}

	.contact-all-rightkey-items .contact-all-rightkey-item {
		height: 32px;
		line-height: 32px;
		padding: 0 15px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.contact-all-rightkey-item:hover {
		background-color: #626262;
	}
	.contact-all-rightkey-cancel{
		border-top: 1px solid #767676;
	}
	.contact-all-fans-group{
		position: absolute;
		background-color: #606060;
		right: -80px;
		transform: translateY(-50%);
		top: 50%;
		width: 80px;
		max-height: 300px;
		overflow: auto;
		font-size: 12px;
	}
	.contact-all-fans-group-item{
		line-height: 30px;
		height: 30px;
		max-width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		padding: 0 4px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.contact-all-fans-group-item-del{
		background-color: #42b983;
	}
	.contact-all-fans-group-item-del span{
		width: 16px;
		height: 16px;
		line-height: 16px;
		text-align: center;
		background: #f16464;
		border-radius: 50%;
		display: inline-block;
		font-size: 12px;
	}
</style>
